import React from 'react';
import { Col, Row } from 'react-bootstrap';

import MetricsSelectorContainer
  from './../Containers/MetricsSelectorContainer';
import MetricsJobInfoContainer
  from './../Containers/MetricsJobInfoContainer';
import ArtifactsMetricsHunterSelectorContainer
  from '../Containers/ArtifactsMetricsHunterSelectorContainer';
import ArtifactMetricsTimingChartContainer
  from './../Containers/ArtifactMetricsTimingChartContainer';
import CaseMetricsDispatcherContainer
  from './../Containers/CaseMetricsDispatcherContainer';
import WorkerThreadTimingChartContainer
  from './../Containers/WorkerThreadTimingChartContainer';

import { metrics, pageTypes } from './../helpers';

const ArtifactsMetricsComponent = () => {
  const ccfCarveTypes = metrics.artifactCarvingTypes(true);
  const ncfCarveTypes = metrics.artifactCarvingTypes(false);

  const charts = [];
  for (let i = 0; i < ccfCarveTypes.length; i++) {
    charts.push([
      <Row key={'carveType' + i}>
        <Col md={6}>
          <h4> NCF - {ncfCarveTypes[i].split(':')[1]} </h4>
          <ArtifactMetricsTimingChartContainer
            carveType={ncfCarveTypes[i]}
            stacked
          />
        </Col>
        <Col md={6}>
          <h4> CCF - {ncfCarveTypes[i].split(':')[1]} </h4>
          <ArtifactMetricsTimingChartContainer
            carveType={ccfCarveTypes[i]}
            isCcf
            stacked
          />
        </Col>
      </Row>
    ]);
  }

  charts.push([
    <Row>
      <Col md={12}>
        <Col md={6} sm={12}>
          <h4> NCF - Total Worker Thread Dequeue Time </h4>
          <WorkerThreadTimingChartContainer stacked />
        </Col>
        <Col md={6} sm={12}>
          <h4> CCF - Total Worker Thread Dequeue Time</h4>
          <WorkerThreadTimingChartContainer isCcf stacked />
        </Col>
      </Col>
    </Row>
  ]);

  return (
    <div>
      <Row>
        <Col sm={10} md={10} mdOffset={1}>
          <Row>
            <MetricsSelectorContainer pageType={pageTypes.ARTIFACTSMETRICS} />
          </Row>
          <Row style={{ marginBottom: '15px' }}>
            <CaseMetricsDispatcherContainer
              jumpDestination={pageTypes.CASEMETRICS}
            />
          </Row>
          <Row>
            <MetricsJobInfoContainer pageType = {pageTypes.ARTIFACTSMETRICS} />
          </Row>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Row>
            <Col md={10}>
              <ArtifactsMetricsHunterSelectorContainer />
            </Col>
          </Row>
          {charts}
        </Col>
      </Row>
    </div>
  );
};

export default ArtifactsMetricsComponent;


// WEBPACK FOOTER //
// src/Components/ArtifactsMetricsComponent.jsx